module.exports = __webpack_public_path__ + "static/about-5e9c25afed7422bb65b2b7bffca93e55.jpg";